const ROUTE_KEY = 'sp_route';
const PARAMS_KEY = 'sp_params';
const TOKEN_KEY = 'sp_token';

function loadPersistedRoute(fallbackRoute) {
  return localStorage.getItem(ROUTE_KEY) || fallbackRoute;
}

function persistRoute(route) {
  localStorage.setItem(ROUTE_KEY, route);
}

function loadPersistedParams() {
  try {
    return JSON.parse(localStorage.getItem(PARAMS_KEY) || '{}');
  } catch (_) {
    return {};
  }
}

function persistParams(params) {
  localStorage.setItem(PARAMS_KEY, JSON.stringify(params));
}

function loadPersistedToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

function persistToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

function clearPersistedToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export {
  loadPersistedRoute,
  persistRoute,
  loadPersistedParams,
  persistParams,
  loadPersistedToken,
  persistToken,
  clearPersistedToken,
};
